import {lazy} from '@aboutyou/lazy-imports';
import {useIsCheckoutPage} from '@aboutyou/router';
import {useBasketCount} from '@aboutyou/user';
import React from 'react';

const CheckoutPreloadLazy = lazy(() =>
  import('./CheckoutPreload').then(mod => ({
    default: mod.CheckoutPreload,
  })),
);

export const CheckoutPreloadConditional = () => {
  const count = useBasketCount();
  const isCheckoutPage = useIsCheckoutPage();

  /**
   * on Checkout Page, since we have AppCheckout we already have the CheckoutPreload datafetcher mounted there without lazy-loading
   * so we don't need to preload it here
   */
  if (isCheckoutPage) {
    return null;
  }

  if (count) {
    return <CheckoutPreloadLazy />;
  }

  return null;
};
